import { render } from "./RouterViewContainer.vue?vue&type=template&id=55f90315&ts=true"
import script from "./RouterViewContainer.vue?vue&type=script&lang=ts"
export * from "./RouterViewContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__